import React, { useState } from 'react';
import './App.css';

function App() {
  const [file, setFile] = useState<File | null>(null);
  const [uploadStatus, setUploadStatus] = useState<string>('');
  const [transcriptionId, setTranscriptionId] = useState<string>('');
  const [transcriptionStatus, setTranscriptionStatus] = useState<string>('');

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setUploadStatus('Uploading...');
    // TODO: Implement actual file upload to your Cloudflare Worker
    // For now, we'll simulate an upload
    setTimeout(() => {
      setUploadStatus('Uploaded successfully');
      setTranscriptionId('sample-id-123');
    }, 2000);
  };

  const checkStatus = async () => {
    if (!transcriptionId) return;

    setTranscriptionStatus('Checking...');
    // TODO: Implement actual status check with your Cloudflare Worker
    // For now, we'll simulate a status check
    setTimeout(() => {
      setTranscriptionStatus('Transcription completed');
    }, 1500);
  };

  return (
    <div className="App">
      <h1>Audio Transcription App</h1>
      <div>
        <input type="file" onChange={handleFileChange} accept="audio/*" />
        <button onClick={handleUpload} disabled={!file}>
          Upload
        </button>
        <p>{uploadStatus}</p>
      </div>
      <div>
        <input
          type="text"
          value={transcriptionId}
          onChange={(e) => setTranscriptionId(e.target.value)}
          placeholder="Enter transcription ID"
        />
        <button onClick={checkStatus}>Check Status</button>
        <p>{transcriptionStatus}</p>
      </div>
    </div>
  );
}

export default App;
